import type { ProductGroup } from "~/features/search/models/models";
import type { UnitType } from "~/features/search/api/fetchFilterConfig";

export const Filter = {
  FACET: "FACET_FILTER",
  TECH_VALUE: "TECH_FILTER",
  TAXONOMY: "TAXONOMY",
  RELEVANT: "RELEVANT",
  SALES: "SALES",
} as const;

export type FilterType = (typeof Filter)[keyof typeof Filter];

export type FilterConfig = FilterGroupData[];

export type FilterGroupData = FacetFilterData | TechValueFilterCategoryData | TaxonomyFilterData | OtherFilterData;
export interface FacetFilterData {
  title: string;
  initiallyExpanded?: boolean; // should this group be expanded on page load, does NOT include expanding "Show more" items
  type: typeof Filter.FACET;
  unitType?: UnitType;
  code: string;
  columnAmount: number; // In how many columns should be facet values layed out
  // Nothing else, because a list of values for a category will come
}

export interface TechValueFilterCategoryData {
  title: string;
  initiallyExpanded?: boolean; // should this group be expanded on page load, does NOT include expanding "Show more" items
  type: typeof Filter.TECH_VALUE;
  facetId: string | null;
  maxElementsVisible?: number; // no value meaning all items should be visible without additional "Show more" link
  items: TechFilter[];
}

export interface TechFilter {
  uid: string;
  title: string;
  abbreviation: string;
  // @deprecated - use abbreviation instead
  tabularTitle: string;
  // @deprecated use sortAsc from TabularColumnDefDTO
  sortAscCode?: string;
  // @deprecated use sortDesc from TabularColumnDefDTO
  sortDescCode?: string;
  description?: string;
  assistantLabel?: string;
  unit?: string;
  visibleOnFilters?: boolean;
}

export interface TaxonomyFilterData {
  type: typeof Filter.TAXONOMY;
  showEmptyCategories: boolean;
  categories: ProductGroup[];
  initiallyExpanded?: boolean;
}

export interface OtherFilterData {
  type: typeof Filter.RELEVANT | typeof Filter.SALES;
}

export function isTechValueFilterCategory(group: FilterGroupData): group is TechValueFilterCategoryData {
  return group.type === Filter.TECH_VALUE;
}
